import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { clearSessionStorage, toastError, DOC_BASE_URL } from '../../utils/constants'
import Header from '../../common_components/Header';
import { emailValidator } from '../../utils/Validator'
import Modal from "react-modal";
import Footerwithdr from '../../common_components/Footerwithdr';
import HeaderWithLogo from '../../common_components/header_with_logo';
import AdminDrawer from '../../common_components/admin_module_drawer';
import { fill_action } from '../../actions/fillCombo_action'
import { Link } from "react-router-dom";
import { getAdminDashboardData_action } from "../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_action"
import { getExhibitionStartDate_action, checkEntryPassExists_action } from '../../actions/vendor_module_action/vendor_exhibition_list_action/vendor_exhibition_list_action'
import { getVendorDownloadCentre_action } from '../../actions/vendor_module_action/vendor_downloadCentre_action'
import VendorExhibitionList from './vendor_exhibition_list/vendor_exhibition_list';
import VendorDashboard from './vendor_dashboard/vendor_dashboard';
import VendorDrawer from '../../common_components/vendor_module_drawer';
import ExhibitorDrawer from '../../common_components/exhibitor_module_drawer';
import VendorRegistrationAU from '../admin_module/vendor/vendorRegistration/vendorRegistration_au';
import VendorWorkOrderAU from '../admin_module/vendor/vendorWorkOrder/vendorWorkOrder_au';
import VendorWorkOrderList from '../admin_module/vendor/vendorWorkOrder/vendorWorkOrder_list';
import VendorPlan from './vendor_plan/vendor_plan';
import VendorPlanRecord from './vendor_plan/vendor_plan_record';
import VendorTaskDetail from './vendor_task/vendor_task_detail';
import ExhibitorEntryPass from "../exhibitor_module/exhibitorEntryPass/exhibitorEntryPass.js";
import ExhibitorExitPass from '../exhibitor_module/exhibitorExitPass/exhibitorExitPass.js';
import VendorStaticList from './vendor_static_list/vendor_static_list.js';
import VendorExhibitorList from './vendor_exhibitor_list/vendor_exhibitor_list.js';
import HallView from '../admin_module/organizer-tracker/hallView/hallView.js';
import LayoutView from '../admin_module/organizer-tracker/layoutView/layoutView.js';
import VendorStallDesignRequestList from './vendor_stallDesignRequest_list/vendor_stallDesignRequest_list.js';
import StallDesignAdmin from '../admin_module/manual_forms_admin/stallDesign_admin/stallDesign_admin.js';
import GraphView from '../admin_module/organizer-tracker/graphView/graphView.js';
import DailyRoutineTaskList from '../admin_module/daily_routine_task/daily_routine_task_list';

class VendorModule extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            summaryPage: sessionStorage.getItem("summaryPage") ? sessionStorage.getItem("summaryPage") : 'vendorDashboard',
            renderKey: 0,
            subPage: null,
            // Input Fields
            pendingPaymentCount: "",
            loginAccesslist: [],
            showExitPassModal: false,
            exitPassMessage: '',
            isMobileMenuOpen: false,
            // Download Centre
            showDownloadCentre: false,
            downloadCentreList: []
        }
        this.getDashboardData = this.getDashboardData.bind(this)
        this.isRouteActive = this.isRouteActive.bind(this)
        this.toNavigate = this.toNavigate.bind(this)
        this.getModuleAccess = this.getModuleAccess.bind(this)
        this.navigateToSubPage = this.navigateToSubPage.bind(this)
    }


    // On Component Load
    componentDidMount() {
        const roleId = sessionStorage.getItem('RoleIDSS')
        if (!sessionStorage.getItem("summaryPage")) {
            sessionStorage.setItem("summaryPage", "vendorDashboard")
        }
        window.addEventListener('vendorNavigate', this.handleVendorNavigate);
        window.addEventListener('vendorOpenDownloadCentre', this.handleOpenDownloadCentre);
        this.getDownloadCentreData();
        // Download Center was picked from the menu on another route
        if (sessionStorage.getItem("openDownloadCentre") === "true") {
            sessionStorage.removeItem("openDownloadCentre");
            this.setState({ showDownloadCentre: true });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('vendorNavigate', this.handleVendorNavigate);
        window.removeEventListener('vendorOpenDownloadCentre', this.handleOpenDownloadCentre);
    }

    handleOpenDownloadCentre = () => {
        this.setState({ showDownloadCentre: true });
    }

    handleVendorNavigate = (e) => {
        const page = e.detail;
        sessionStorage.setItem("summaryPage", page);
        this.setState(prevState => ({
            summaryPage: page,
            subPage: null,
            renderKey: prevState.renderKey + 1
        }));
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            const page = sessionStorage.getItem("summaryPage") || "vendorDashboard";

            if (page !== this.state.summaryPage) {
                this.setState({
                    summaryPage: page,
                    subPage: null
                });
            }
        }
    }

    // Get DashBoard Data
    getDashboardData() {
        this.setState({ isLoading: true })
        this.props.getAdminDashboardData_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Admin Dashboard Data ------->", data.data)
                    this.setState({
                        isLoading: false,
                        pendingPaymentCount: data.data[0]['Count_Of_Payment']
                    })
                } else {
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // Download Centre
    getDownloadCentreData = () => {
        this.props.getVendorDownloadCentre_action()
            .then((res) => {
                if (res != null && res.error === 0) {
                    this.setState({ downloadCentreList: res.data?.vendorPlanList || [] })
                } else {
                    this.setState({ downloadCentreList: [] })
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ downloadCentreList: [] })
            })
    }

    toggleDownloadCentre = () => {
        this.setState(prevState => ({ showDownloadCentre: !prevState.showDownloadCentre }))
    }

    // Append the base url and open the document in a new tab
    openDownloadCentreFile = (path) => {
        if (path == null || path == '') {
            toastError("File not available")
            return
        }
        const filePath = String(path).startsWith('http')
            ? path
            : `${DOC_BASE_URL}${String(path).startsWith('/') ? '' : '/'}${path}`
        window.open(filePath, "_blank")
    }

    hasOnlyService32() {
        const sessionServiceList = sessionStorage.getItem("serviceids") ? JSON.parse(sessionStorage.getItem("serviceids")) : []
        return sessionServiceList != null && sessionServiceList.length === 1 && sessionServiceList[0]?.ServiceId === 32
    }

    isRouteActive(routePath) {
        console.log(this.props.location)
        return this.props.location.pathname == routePath
    }

    navigateToSubPage(subPage) {
        this.setState({ subPage });
    }

    toNavigate() {
        const { summaryPage, subPage } = this.state

        if (subPage === 'VendorPlanRecord') {
            return <VendorPlanRecord onNavigateBack={() => this.setState({ subPage: null })} />;
        }

        if (subPage === 'VendorWorkOrderAU') {
            return <VendorWorkOrderAU onNavigateBack={() => this.setState({ subPage: null })} />;
        }

        if (summaryPage == 'vendorExhibitionList') {
            return <VendorExhibitionList />
        }
        else if (summaryPage == 'vendorDashboard') {
            return <VendorDashboard
                onNavigateToOrder={() => this.setState({ summaryPage: 'vendorExhibitionList' })}
                onNavigateToScopeOfWork={() => this.setState({ summaryPage: 'VendorWorkOrderList' })}
                onNavigateToProfile={() => this.setState({ summaryPage: 'VendorRegistrationAU' })}
                onNavigateToWorkOrder={() => this.navigateToSubPage('VendorWorkOrderAU')}
                onNavigateToPlan={() => this.setState({ summaryPage: 'VendorPlan' })}
                onNavigateToRecord={() => this.navigateToSubPage('VendorPlanRecord')}
                onNavigateToEntryPass={() => this.setState({ summaryPage: 'EntryPass' })}
                onNavigateToExitPass={() => this.setState({ summaryPage: 'ExitPass' })}
                onNavigateToStallDesignRequestList={() => this.setState({ summaryPage: 'Stall Design Request' })}
            />
        }
        else if (summaryPage == 'VendorRegistrationAU') {
            return <VendorRegistrationAU key={`VendorRegistrationAU-${this.state.renderKey}`} isEmbedded={true} />
        }
        else if (summaryPage == 'VendorWorkOrderList') {
            return <VendorWorkOrderList key={`VendorWorkOrderList-${this.state.renderKey}`} onNavigateToWorkOrder={() => this.navigateToSubPage('VendorWorkOrderAU')} />
        }
        else if (summaryPage == 'VendorPlan') {
            return <VendorPlan onNavigateToRecord={() => this.navigateToSubPage('VendorPlanRecord')} />
        }
        else if (summaryPage == 'VendorTaskDetail') {
            return <VendorTaskDetail />
        }
        else if (summaryPage == 'EntryPass') {
            return <ExhibitorEntryPass />
        }
        else if (summaryPage == 'ExitPass') {
            return <ExhibitorExitPass />
        }
        else if (summaryPage == 'HallLayout') {
            return <LayoutView />
        }
        else if (summaryPage == 'VendorStaticList') {
            return <VendorStaticList />
        }
        else if (summaryPage == 'VendorExhibitorList') {
            return <VendorExhibitorList />
        }
        else if (summaryPage == 'stallDesignRequestList') {
            return <VendorStallDesignRequestList />
        }
        else if (summaryPage == 'StallDesignAdmin') {
            return <StallDesignAdmin />
        }
        else if (summaryPage == 'GraphView') {
            return <GraphView />
        }
        if (summaryPage == 'dailyRoutineTaskList') {
            return <DailyRoutineTaskList />
        }
    }

    getModuleAccess(ModuleID) {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == ModuleID);
        if (moduleAccess) {
            return moduleAccess.ReadAccess;
        } else {
            return false
        }
        return false;
    };

    // handleExitPassClick = () => {
    //     this.setState({ isLoading: true });
    //     const exhibitionID = JSON.parse(sessionStorage.getItem("sessionExhibitionID"));

    //     this.props.getExhibitionStartDate_action(exhibitionID)
    //         .then((res) => {
    //             this.setState({ isLoading: false });
    //             if (res.error === 0 && res.data?.exhibitorList?.length > 0) {
    //                 const exhibitionDateFrom = new Date(res.data.exhibitorList[0].ExhibitionDateFrom);
    //                 const currentDate = new Date();
    //                 currentDate.setHours(0, 0, 0, 0);
    //                 exhibitionDateFrom.setHours(0, 0, 0, 0);

    //                 if (exhibitionDateFrom <= currentDate) {
    //                     this.setState({ summaryPage: 'ExitPass', subPage: null }, () => {
    //                         sessionStorage.setItem("summaryPage", "ExitPass");
    //                     });
    //                 } else {
    //                     const formattedDate = exhibitionDateFrom.toLocaleDateString('en-GB');
    //                     this.setState({
    //                         showExitPassModal: true,
    //                         exitPassMessage: `Material Exit pass will be available from ${formattedDate}`
    //                     });
    //                 }
    //             } else {
    //                 toastError("Unable to retrieve exhibition date");
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //             this.setState({ isLoading: false });
    //             toastError("Error checking exhibition date");
    //         });
    // };

    handleExitPassClick = () => {
        this.setState({ isLoading: true });
        const exhibitionID = JSON.parse(sessionStorage.getItem("sessionExhibitionID"));

        this.props.checkEntryPassExists_action()
            .then((res) => {
                this.setState({ isLoading: false });
                if (res.error === 0 && res.data?.entryPassCount?.[0]?.Cnt > 0) {
                    this.setState({ summaryPage: 'ExitPass', subPage: null }, () => {
                        sessionStorage.setItem("summaryPage", "ExitPass");
                    });
                } else {
                    this.setState({
                        showExitPassModal: true,
                        exitPassMessage: 'Please create an Material Entry pass before accessing Material Exit pass'
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isLoading: false });
                toastError("Error checking exhibition date");
            });
    };

    render() {
        const { isLoading, pendingPaymentCount, summaryPage, showExitPassModal, exitPassMessage, isMobileMenuOpen, showDownloadCentre, downloadCentreList } = this.state
        return (
            <>


                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />

                {showExitPassModal && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Material Exit pass</h5>
                                </div>
                                <div className="modal-body">
                                    <p>{exitPassMessage}</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-aqua" onClick={() => this.setState({ showExitPassModal: false })}>
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <HeaderWithLogo
                    changeSummaryPage={(page) => {
                        sessionStorage.setItem("summaryPage", page);
                        this.setState(prevState => ({
                            summaryPage: page,
                            subPage: null,
                            renderKey: prevState.renderKey + 1
                        }));
                    }}
                />
                {/* <ExhibitorDrawer /> */}
                <>
                    {/* <AdminDrawer /> */}
                    {/*app-content open*/}
                    <div className="app-content with-dr-container com-height" >
                        <div className="navg mt-0">
                            <ul className="nav nav-pills tab-scroll-fixed ">

                                <li onClick={() => this.setState({ summaryPage: 'vendorDashboard', subPage: null }, () => {
                                    sessionStorage.setItem("summaryPage", "vendorDashboard")
                                })} className="nav-item ">
                                    <a className={summaryPage == 'vendorDashboard' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                        Dashboard
                                    </a>
                                </li>
                                {/* <li onClick={() => this.setState({ summaryPage: 'VendorRegistrationAU', subPage: null }, () => {
                                    sessionStorage.setItem("summaryPage", "VendorRegistrationAU")
                                })} className="nav-item ">
                                    <a className={summaryPage == 'VendorRegistrationAU' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                        Profile
                                    </a>
                                </li>
                                <li onClick={() => this.setState({ summaryPage: 'VendorWorkOrderList', subPage: null }, () => {
                                    sessionStorage.setItem("summaryPage", "VendorWorkOrderList")
                                })} className="nav-item ">
                                    <a className={summaryPage == 'VendorWorkOrderList' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                        Scope of Work
                                    </a>
                                </li> */}
                                {(sessionStorage.getItem("isStallDesignApproverVendor") == 'true' ? false : true) &&
                                    (!this.hasOnlyService32() &&
                                        <li onClick={() => this.setState({ summaryPage: 'vendorExhibitionList', subPage: null }, () => {
                                            sessionStorage.setItem("summaryPage", "vendorExhibitionList")
                                        })} className="nav-item ">
                                            <a className={summaryPage == 'vendorExhibitionList' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                                Order
                                            </a>
                                        </li>)
                                }
                                {
                                    (sessionStorage.getItem("isStallDesignApproverVendor") == 'true' || sessionStorage.getItem("isStallDesignVendor") == 'true') &&
                                    <>
                                        {
                                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != '17' ?
                                                <li onClick={() => this.setState({ summaryPage: 'stallDesignRequestList', subPage: null }, () => {
                                                    sessionStorage.setItem("summaryPage", "stallDesignRequestList")
                                                })} className="nav-item ">
                                                    <a className={summaryPage == 'stallDesignRequestList' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                                        Booth Design Request
                                                    </a>
                                                </li> :
                                                <li onClick={() => this.setState({ summaryPage: 'StallDesignAdmin', subPage: null }, () => {
                                                    sessionStorage.setItem("summaryPage", "StallDesignAdmin")
                                                })} className="nav-item ">
                                                    <a className={summaryPage == 'StallDesignAdmin' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                                        Booth Design Approval
                                                    </a>
                                                </li>
                                        }
                                    </>
                                }
                                <li onClick={() => this.setState({ summaryPage: 'VendorPlan', subPage: null }, () => {
                                    sessionStorage.setItem("summaryPage", "VendorPlan")
                                })} className="nav-item ">
                                    <a className={summaryPage == 'VendorPlan' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                        Plan and Timeline
                                    </a>
                                </li>
                                <li onClick={() => this.setState({ summaryPage: 'VendorTaskDetail', subPage: null }, () => {
                                    sessionStorage.setItem("summaryPage", "VendorTaskDetail")
                                })} className="nav-item ">
                                    <a className={summaryPage == 'VendorTaskDetail' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                        Service Partner Task By Organizer
                                    </a>
                                </li>
                                <li onClick={() => this.setState({ summaryPage: 'dailyRoutineTaskList' }, () => {
                                    sessionStorage.setItem("summaryPage", "dailyRoutineTaskList")
                                })} className="nav-item ">
                                    {" "}
                                    <a className={summaryPage == 'dailyRoutineTaskList' ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                        Routine Task{" "}
                                    </a>{" "}
                                </li>
                                <li onClick={() => this.setState({ summaryPage: 'VendorStaticList', subPage: null }, () => {
                                    sessionStorage.setItem("summaryPage", "VendorStaticList")
                                })} className="nav-item ">
                                    <a className={summaryPage == 'VendorStaticList' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                        Service Partner List
                                    </a>
                                </li>
                                {/* <li onClick={() => this.setState({ summaryPage: 'EntryPass', subPage: null }, () => {
                                    sessionStorage.setItem("summaryPage", "EntryPass")
                                })} className="nav-item ">
                                    <a className={summaryPage == 'EntryPass' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                        Material Entry pass
                                    </a>
                                </li>
                                <li onClick={this.handleExitPassClick} className="nav-item ">
                                    <a className={summaryPage == 'ExitPass' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                        Material Exit pass
                                    </a>
                                </li> */}
                                {/* <li onClick={() => this.setState({ summaryPage: 'HallLayout', subPage: null }, () => {
                                    sessionStorage.setItem("summaryPage", "HallLayout")
                                })} className="nav-item ">
                                    <a className={summaryPage == 'HallLayout' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                        Hall Layout
                                    </a>
                                </li> */}
                                <li onClick={() => this.setState({ summaryPage: 'VendorExhibitorList', subPage: null }, () => {
                                    sessionStorage.setItem("summaryPage", "VendorExhibitorList")
                                })} className="nav-item ">
                                    <a className={summaryPage == 'VendorExhibitorList' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                        Exhibitor List
                                    </a>
                                </li>
                                {this.hasOnlyService32() &&
                                    <li onClick={() => this.setState({ summaryPage: 'GraphView', subPage: null }, () => {
                                        sessionStorage.setItem("summaryPage", "GraphView")
                                    })} className="nav-item ">
                                        <a className={summaryPage == 'GraphView' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                            Progress View
                                        </a>
                                    </li>}
                                {/* <li className="nav-item">
                                    <a 
                                        href="/assets/VENDOR_MANUAL.pdf" 
                                        download="VENDOR_MANUAL.pdf"
                                        className="nav-link px-3 py-2"
                                        title="Detailed User Manual"
                                    >
                                        <i className="fa fa-download"></i> User Manual
                                    </a>
                                </li> */}

                            </ul>
                        </div>
                        {this.toNavigate()}
                    </div>
                    <VendorDrawer summaryPage={summaryPage} />
                </>

                {/* Download Centre side panel */}
                {showDownloadCentre && (
                    <>
                        <div
                            onClick={this.toggleDownloadCentre}
                            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1050 }}
                        ></div>
                        <div
                            style={{
                                position: 'fixed', top: 0, right: 0, height: '100%', width: '380px', maxWidth: '90%',
                                background: '#fff', zIndex: 1051, boxShadow: '-2px 0 8px rgba(0,0,0,0.2)',
                                display: 'flex', flexDirection: 'column'
                            }}
                        >
                            <div className="d-flex justify-content-between align-items-center px-3 py-2 bg-light border-bottom">
                                <h6 className="mb-0">Download Center</h6>
                                <button type="button" className="btn-close" onClick={this.toggleDownloadCentre} style={{ fontSize: '12px' }}></button>
                            </div>
                            <div className="p-2" style={{ overflowY: 'auto', flex: 1 }}>
                                {downloadCentreList != null && downloadCentreList.length > 0 ? (
                                    downloadCentreList.map((doc, index) => {
                                        const title = doc.Title || doc.title || doc.DocumentName || 'Document'
                                        const filePath = doc.FilePath || doc.Filepath || doc.filePath || doc.filepath || doc.DocumentPath || ''
                                        return (
                                            <div key={index} className="card border p-2 mb-2 download-center-card" onClick={() => this.openDownloadCentreFile(filePath)}>
                                                <div className="card-body p-1 d-flex justify-content-between align-items-center gap-2" style={{ textAlign: 'left' }}>
                                                    <span className="text-dark text-break" style={{ flex: 1, textAlign: 'left' }}>{title}</span>
                                                    <i
                                                        className="bi bi-eye grid-icon"
                                                        title="View"
                                                        style={{ flexShrink: 0 }}
                                                    ></i>
                                                </div>
                                            </div>
                                        )
                                    })
                                ) : (
                                    <p className="text-muted text-center mt-3 mb-0">No documents available</p>
                                )}
                            </div>
                        </div>
                    </>
                )}

                <Footerwithdr />

            </>
        );
    }


}

export default withRouter(connect(null, { getAdminDashboardData_action, getExhibitionStartDate_action, checkEntryPassExists_action, getVendorDownloadCentre_action })(VendorModule));
